import React, { Fragment } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
} from "react-table";

import { modifyCell, modifyCellHeader } from "./cell_formatter";
import Images from "../../utils/styles/images";
import Pagination from "./Pagination";

function Table({
  columns,
  data,
  handleViewClick,
  handleActionHeaderClick,
  handleFltHeader,
  handleActionClick,
  pageSelect,
  HightTable,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageCount,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Fragment>
      <div className="untHld-list-container" style={{ height: HightTable }}>
        <table className="untHld-table" {...getTableProps()}>
          <thead className="untHld-head-container">
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="untHld-head-row"
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="untHld-header"
                    style={{
                      width: column.render("width"),
                      paddingLeft: column.render("paddingLeft"),
                    }}
                  >
                    {modifyCellHeader(
                      column.render("Header"),
                      handleActionHeaderClick,
                      handleFltHeader
                    )}
                  </th>
                ))}
                <th className="untHld-table-floating-header" />
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps} className="untHld-table-body">
            {page.length <= 0 ? (
              <tr className="untHld-table-empty-row">
                <td colSpan={14}>
                  <div className="untHld-table-no-data">
                    <img src={Images.noData.board} alt="no-data-found-board" />
                    <p className="untHld-table-no-data-header">
                      No result found
                    </p>
                    <p className="untHld-table-no-data-body">
                      We couldn’t find what you are looking for.
                      <br /> Please try again.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} className="untHld-table-row">
                    {row.cells.map((cell) => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className="untHld-cell"
                          style={{
                            width: cell.render("width"),
                            paddingLeft: cell.render("paddingLeft"),
                            textAlign: cell.render("textAlign"),
                          }}
                        >
                          {modifyCell(
                            cell.render("Cell"),
                            pageSelect,
                            pageSize,
                            handleActionClick
                          )}
                        </td>
                      );
                    })}
                    <td className="untHld-table-floating-cell">
                      <button onClick={() => handleViewClick(row)}>
                        <img src={Images.clients.view} alt="eye-icon" />
                        <p>View</p>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {pageCount > 1 ? (
        <Pagination
          pageIndex={pageIndex}
          previousPage={previousPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          total={pageCount}
          gotoPage={gotoPage}
        />
      ) : null}
    </Fragment>
  );
}

export default Table;
